import PopularBlog1 from "../../assets/upload/small_01.jpg"
import PopularBlog2 from "../../assets/upload/small_02.jpg"
import PopularBlog3 from "../../assets/upload/small_03.jpg"
const PopularPostData = [
    {
        id: 1,
        imagePopular: PopularBlog1,
        title: "Banana-chip chocolate cake recipe with customs",
        star:  5,
        srcLink: 'https://www.google.com',
    },
    {
        id: 2,
        imagePopular: PopularBlog2,
        title: "10 practical ways to choose organic vegetables",
        star: 4,
        srcLink: 'https://www.google.com',
    },
    {
        id: 3,
        imagePopular: PopularBlog3,
        title: "We are making homemade ravioli, nice and good",
        star: 3,
        srcLink: 'https://www.google.com',
    },
]

export default PopularPostData;